import React, { useEffect } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../../common/Header";
import FooterInnerPagee from "../../../common/FooterInnerPagee";
import image1 from "../../../assets/people/peoplebannerimg.png";
import img1 from "../../../assets/people/img1.jpeg";
import img2 from "../../../assets/people/img2.jpeg";
import img3 from "../../../assets/people/img3.jpg";
import img4 from "../../../assets/people/img4.jpeg";
import img5 from "../../../assets/people/img5.jpeg";
import img6 from "../../../assets/people/img6.jpeg";
import img7 from "../../../assets/people/img7.jpeg";
import img8 from "../../../assets/people/img8.jpeg";
import img9 from "../../../assets/people/img9.jpeg";
import img10 from "../../../assets/people/img10.jpeg";
import img11 from "../../../assets/people/img11.png";
import img12 from "../../../assets/people/img12.jpeg";
import img13 from "../../../assets/MohammedNisham.jpeg";
import LeftSideNavigation from "../../../common/LeftSideNavigation";

const Overview = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const teamCategories = [
    {
      title: "Founder Members",
      members: [
        {
          src: img12,
          name: "Dr. B Mohammed Nowshad",
          position:
            "Founder & Chairman, REEF (Research and Environmental Education Foundation)",
          email: "nowshad@reef.org.in",
          qualifications: [
            "Kerala University of Fisheries and Ocean Studies",
          ],
          description: "Chairman overseeing overall strategic initiatives.",
          fullProfile1:
            "Dr. B. Mohammed Nowshad Founder & Chairman, REEF (Research and Environmental Education Foundation). Mohammed Nowshad is a passionate marine conservationist and researcher, hailing from the Lakshadweep Archipelago. As the Founder and Chairman of REEF, he brings a deep-rooted commitment to protecting the fragile marine ecosystems of the islands while empowering the communities who depend on them.",
          fullProfile2:
            "With a Ph.D. in marine biology, Nowshad specializes in the Echinoderms in the unique geomorphological zones of Lakshadweep. His research integrates science with traditional knowledge to inform conservation strategies that are locally relevant and ecologically sound. Nowshad's vision for REEF is grounded in three pillars: science, community, and sustainability. Under his leadership, REEF has expanded its outreach through innovative community awareness programs, citizen science initiatives, and habitat restoration efforts across the atolls.",
          fullProfile3:
            "An advocate for inclusive conservation, Nowshad actively engages with fishermen, students, youth, and women's self-help groups, fostering stewardship and climate resilience through education and empowerment. His work not only advances ecological research but also uplifts local voices in environmental decision-making. With over a decade of experience in marine research and grassroots activism, Nowshad continues to inspire a generation of conservationists dedicated to preserving the natural and cultural heritage of Lakshadweep.",
        },
        {
          src: img11,
          name: "Abdul Riyas",
          position: "DIRECTOR OF RESEARCH, FOUNDER AND SECRETARY OF Research and Environmental Education Foundation (REEF).",
          email: "riyasaqua@gmail.com ",
          qualifications: [
            "Ph.D. in Marine Biology – University of Kerala",
            "M.Sc in Environmental Science – University of Calicut",
          ],
          description: "Leads the research team and project innovations.",
          fullProfile1:
            "Abdul Riyas C. is a passionate marine researcher and conservationist from the Lakshadweep Archipelago. As Secretary and co-founder of REEF, he plays a leading role in promoting coral reef restoration and sustainable marine resource management in the islands. Currently pursuing his Ph.D. at the Kerala University of Fisheries and Ocean Studies (KUFOS), his research focuses on the status, threats, and conservation strategies for coral reefs in Lakshadweep.",

          fullProfile2:
            "Mr. Riyas combines field science with strong community involvement, working closely with fishers, youth, and local institutions to enhance reef resilience through citizen science and participatory conservation. He has led underwater surveys across the archipelago, documenting marine biodiversity and implementing reef nursery projects for ecological restoration.\nA certified SCUBA diver with over 400 dives, he brings deep field experience and scientific insight to every initiative. His notable contributions include research on coral nursery techniques, the ecological impacts of tropical cyclones, and plastic pollution in coastal ecosystems. He has shared his findings at prominent national and international platforms, furthering global understanding of fragile island ecosystems.",

          fullProfile3:
            "Born and raised in Kavaratti, Mr. Riyas is deeply connected to Lakshadweep’s culture and ecology. His work reflects a strong belief in community-led conservation, ensuring the coral reefs that sustain the islands’ heritage and livelihoods are protected for future generations.",
        },

        {
          src: img10,
          name: "RAHEEM",
          position: "Founder, Treasurer & Head Operations",
          email: "raheemagatti@gmail.com",
          qualifications: [
            "PADI Open Water SCUBA Instructor (PADI #339587)",
            "EFR (Emergency First Response) Instructor – PADI",
            "Specialty Instructor – Deep Diving, Night Diving, Oxygen Provision, Equipment Handling",
            "Scientific Diver Certification – Department of Science & Technology (2015)",
          ],

          description:
            "PADI Instructor & Indigenous Marine Scientist, REEF – Agatti",
          fullProfile1:
            "Mohamed Abdul Raheem is a PADI-certified Open Water SCUBA Instructor (PADI #339587) and an Indigenous Marine Scientist with over 16 years of experience in diving, marine research, and community-led conservation in Lakshadweep.\n\nHe is certified as a PADI Instructor, EFR Instructor, and Specialty Instructor in deep diving, night diving, oxygen provision, and equipment handling. In addition, he holds a Scientific Diver Certification from the Department of Science & Technology (2015).",

          fullProfile2:
            "Raheem has trained 500+ divers ranging from beginners to advanced levels, while also spearheading reef restoration projects and citizen science initiatives. His expertise lies in combining traditional ecological knowledge with modern marine science, strengthening coral reef monitoring, marine biodiversity studies, and climate resilience research.",

          fullProfile3:
            "As a founding member of the Research and Environmental Education Foundation (REEF), he actively contributes to marine stewardship, policy discussions, and youth mentorship in sustainable diving practices. With over 1000 logged dives across Lakshadweep and Southeast Asia, Raheem continues to champion safe, eco-conscious diving and community-based conservation.",
        },
      ],
    },
  ];

  return (
    <>
      <Grid container>
        <Header />
        {/* Full-width Hero Image */}
        <Grid
          item
          xs={12}
          sx={{
            height: { xs: "60vh", md: "70vh" },
            backgroundImage: `url(${image1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {/* Main Content Area - Below Hero Image */}
        <Grid container sx={{ bgcolor: "#f5f5f5", color: "#fff" }}>
          {/* For desktop - Left Side Navigation appears first (left side) */}
          <Grid
            item
            md={3}
            sx={{
              p: 3,
              display: { xs: "none", md: "block" },
              mt: 11,
            }}
          >
            <LeftSideNavigation />
          </Grid>

          {/* Right Side Content - Takes full width on mobile, 75% on desktop */}
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              p: 3,
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)", // Added box shadow
              borderRadius: "8px", // Added border radius
              margin: { md: "24px 24px 24px 0" }, // Added margin for desktop
              backgroundColor: "#fff", // Added white background
            }}
          >
            {teamCategories.map((category, catIndex) => (
              <Grid
                key={catIndex}
                item
                xs={12}
                sx={{
                  px: 3,
                  py: 4,
                  justifyContent: "center",
                  borderBottom:
                    catIndex !== teamCategories.length - 1
                      ? "1px solid #eee"
                      : "none", // Lighter border
                }}
              >
                <Typography
                  variant="h5"
                  align="center"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    mb: 3,
                    fontFamily: "Montserrat, sans-serif",
                    color: "#000",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                  }}
                >
                  {category.title}
                </Typography>
                <Grid container spacing={3} justifyContent="center">
                  {category.members.map((member, memIndex) => {
                    const globalIndex = `${catIndex}-${memIndex}`;
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={member.name}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: 250,
                            height: "100%",
                            borderRadius: 3,
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            // boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Shadow for cards
                            transition:
                              "transform 0.3s ease, box-shadow 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-5px)",
                              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
                            },
                          }}
                          onClick={() =>
                            navigate(`/profile/${globalIndex}`, {
                              state: { member },
                            })
                          }
                        >
                          <Box
                            sx={{
                              height: 360,
                              overflow: "hidden",
                              flexShrink: 0,
                              "& img": {
                                transition: "transform 0.5s ease",
                              },
                              "&:hover img": {
                                transform: "scale(1.05)",
                              },
                            }}
                          >
                            <img
                              src={member.src}
                              alt={member.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              p: 2,
                              backgroundColor: "#fff",
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              color="#000"
                              sx={{
                                fontFamily: "Montserrat, sans-serif",
                                mb: 1,
                              }}
                            >
                              {member.name}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                fontFamily: "Montserrat, sans-serif",
                                letterSpacing: 0,
                                fontSize: "0.875rem",
                              }}
                            >
                              {member.position}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            ))}
          </Grid>

          {/* For mobile - Left Side Navigation appears after main content */}
          <Grid
            item
            xs={12}
            sx={{
              p: 3,
              display: { xs: "block", md: "none" },
            }}
          >
            <LeftSideNavigation />
          </Grid>
        </Grid>
      </Grid>
      <FooterInnerPagee />
    </>
  );
};

export default Overview;
